<template>
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div class="lef-one">
        <a-button class="btn-primary" @click="updateDatas">刷新数据</a-button>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table :columns="columns" :dataSource="dataSource" :loading="searchLoading" :pagination="false" :scroll="{ y: tableHeight }" class="table" size="small">
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'name'">
        <div style="display: flex">
          <img
            :src="imgCut(record.image ? record.image : companyLogo, 'xl')"
            alt="房源图片"
            fit="fill"
            style="width: 80px; height: 50px; object-fit: cover; cursor: pointer"
            @click="goRouter('/pms/landlord/room/details', record)"
          />
          <div class="editable-cell house-info">
            <div v-if="editId.includes(record.id)" class="editable-cell-input-wrapper">
              <a-input v-model:value="record.name" size="small"></a-input>
              <check-outlined class="editable-cell-icon-check" @click="editSave(record)" />
            </div>
            <div v-else class="editable-cell-text-wrapper">
              {{ record.name }}
              <edit-outlined class="f-c-999 editable-cell-icon" style="margin-left: 10px; cursor: pointer" @click="editId.push(record.id)" />
            </div>
          </div>
        </div>
      </template>
      <template v-if="column.key == 'channel'">
        <div class="logo">
          <a-avatar v-for="(item, index) of record.ota_list" :key="index" :size="20" :src="item.logo" :title="item.ota_name" class="avatar" />
          <plus-circle-outlined class="f-20" style="color: #1890ff; cursor: pointer" @click="goRouter('/pms/landlord/room/details', record, 4)" />
        </div>
      </template>
      <template v-if="column.key == 'operate'">
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <DownOutlined />
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item @click="handleDel(record)">
                <div class="f-c-red">移除此房型</div>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </template>
  </a-table>

  <!-- 分页 -->
  <MyPagination :pageTotal="pageTotal" @onShowSizeChange="onShowSizeChange" @pageChange="pageChange" />
</template>

<script>
import { onMounted, reactive, toRefs, watch } from 'vue';
import { reportStatJsList, reportStatJsUpdateDatas } from '@/api/api';
import { CheckOutlined, DownOutlined, EditOutlined, PlusCircleOutlined } from '@ant-design/icons-vue';
import useUtils from '@/hooks/useUtils.js'; //工具库
// import { verifyPrice } from "@/common/validator";
import store from '@/store/pms/landlord/index'; //VUEX
import router from '@/router/index';

export default {
  components: {
    PlusCircleOutlined,
    DownOutlined,
    // PlusOutlined,
    EditOutlined,
    // LoadingOutlined,
    CheckOutlined,
  },
  setup() {
    let { imgCut, countModal, countTable } = useUtils();

    // 搜索
    let search = reactive({
      topDom: '',
      searchForm: {
        name: '',

        start: 0,
        limit: store.getters.getPageSize,
      },
      searchLoading: false,
      handleOpen(params) {
        search.positionModal = countModal(params);
      },
    });

    // 表格
    let table = reactive({
      editId: [],
      tableHeight: '',
      dataSource: [],
      columns: [
        {
          title: '日期',
          dataIndex: 'date',
          key: 'date',
          align: 'center',
        },
        {
          title: '订单总数',
          dataIndex: 'orderTotal',
          key: 'orderTotal',
          align: 'center',
        },
        {
          title: '订单上报成功数',
          dataIndex: 'orderSuccess',
          key: 'orderSuccess',
          align: 'center',
        },
        {
          title: '订单上报失败数',
          dataIndex: 'orderFail',
          key: 'orderFail',
          align: 'center',
        },
        {
          title: '订单未上报数',
          dataIndex: 'orderUnReport',
          key: 'orderUnReport',
          align: 'center',
        },
        {
          title: '登记总数',
          dataIndex: 'checkInTotal',
          key: 'checkInTotal',
          align: 'center',
        },
        {
          title: '登记上报成功数',
          dataIndex: 'checkInSuccess',
          key: 'checkInSuccess',
          align: 'center',
        },
        {
          title: '登记上报失败数',
          dataIndex: 'checkInFail',
          key: 'checkInFail',
          align: 'center',
        },
        {
          title: '登记未上报数',
          dataIndex: 'checkInUnReport',
          key: 'checkInUnReport',
          align: 'center',
        },
        {
          title: '开锁上报成功数',
          dataIndex: 'doorSuccess',
          key: 'doorSuccess',
          align: 'center',
        },
        {
          title: '开锁上报失败数',
          dataIndex: 'doorFail',
          key: 'doorFail',
          align: 'center',
        },
        {
          title: '开锁未上报数',
          dataIndex: 'doorUnReport',
          key: 'doorUnReport',
          align: 'center',
        },
      ],
      companyLogo: JSON.parse(sessionStorage.getItem('companyInfo') || '{}').logo || '',
      getTableList() {
        search.searchLoading = true;
        reportStatJsList({
          start: search.searchForm.start,
          limit: search.searchForm.limit,
        })
          .then(res => {
            table.dataSource = res.data.list;
            pagination.pageTotal = res.data.count;
            search.searchLoading = false;
          })
          .catch(() => {
            search.searchLoading = false;
          });
      },
      updateDatas() {
        reportStatJsUpdateDatas({})
          .then(res => {
            console.log(res);
            table.getTableList();
          })
          .catch(() => {
            search.searchLoading = false;
          });
      },
      goRouter(url, params = {}, tab = 1) {
        router.push({ path: url, query: { rid: params.id, tab: tab } });
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableList();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableList();
      },
    });

    watch(
      () => store.state.ContentHeight,
      () => {
        table.tableHeight = countTable(search.topDom) - 15;
      }
    );

    onMounted(() => {
      table.getTableList();
      table.tableHeight = countTable(search.topDom) - 15;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .avatar {
    margin-right: 2px;
  }
}

.house-info {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 10px;
}

.modal-header {
  padding: 5px 10px;
  background-color: #f4f4f4;
}

.modal-content {
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 50px;

  .opt-one {
    padding: 1px 8px;
    border: 1px solid #f4f4f4;
    margin-right: 10px;
  }
}

.modal-ctitle {
  margin-bottom: 20px;
  padding: 5px;
  font-weight: bold;
  border-bottom: 1px solid #f2f2f2;
}

:deep(.avatar-uploader > .ant-upload) {
  width: 133px !important;
  height: 100px !important;
}

:deep(.ant-upload-select-picture-card i) {
  font-size: 32px;
  color: #999;
}

:deep(.ant-upload) {
  width: 133px !important;
  height: 100px !important;
  padding: 0 !important;
}

:deep(.ant-upload-select-picture-card .ant-upload-text) {
  margin-top: 8px;
  color: #666;
}

.editable-cell {
  position: relative;

  .editable-cell-input-wrapper,
  .editable-cell-text-wrapper {
    // padding-right: 24px;
    display: flex;
    align-items: center;
  }

  .editable-cell-text-wrapper {
    // padding: 5px 24px 5px 5px;
  }

  .editable-cell-icon,
  .editable-cell-icon-check {
    // position: absolute;
    // right: 0;
    // width: 20px;
    cursor: pointer;
  }

  .editable-cell-icon {
    margin-top: 4px;
    display: none;
  }

  .editable-cell-icon-check {
    line-height: 28px;
  }

  .editable-cell-icon:hover,
  .editable-cell-icon-check:hover {
    color: #108ee9;
  }

  .editable-add-btn {
    margin-bottom: 8px;
  }
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}
</style>
